// extracted by mini-css-extract-plugin
export default {"lightButton":"LightButton_lightButton__ziuCk"};